import { defineComponent, reactive, toRefs, watchEffect } from '@vue/composition-api';
import { Upload, Icon } from 'ant-design-vue';
import { ossRequest, parseOSSResponse } from '@/tslibs/utils/upload';
/**
 * 判断文件格式是否符合要求
 * png / jpg
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-19 00:09:15
 */
const interceptFileType = (file) => ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
/** 1MB */
const ONE_MB = 1024 * 1024;
/** 图片最大2MB */
const IMAGE_MAX_SIZE = ONE_MB * 2;
/**
 * 判断文件大小(max 2MB)
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-21 20:06:47
 */
const interceptFileSize = (file) => file.size <= IMAGE_MAX_SIZE;
/**
 * 获取宽高数据
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-21 20:29:57
 */
const getRect = async (file) => {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
                const width = image.width;
                const height = image.height;
                resolve({ width, height });
            };
        };
        reader.readAsDataURL(file);
    });
};
export default defineComponent({
    name: 'AnotherUploader',
    props: {
        value: String,
        /** 无上传图时提示文本 */
        emptyText: {
            type: [String, Function],
            default: '添加图片',
        },
        /** 上传成功回调 */
        onSuccess: {
            type: Function,
            required: true,
        },
        /** 最小宽高范围 */
        minSizeRange: {
            type: Array,
        },
        /** 最大宽高范围 */
        maxSizeRange: {
            type: Array,
        },
    },
    setup(props, ctx) {
        const state = reactive({
            url: '',
            data: {
                key: '',
                host: '',
                policy: '',
                OSSAccessKeyId: '',
                signature: '',
                success_action_status: -1,
            },
        });
        const setUrl = (url) => {
            state.url = url;
        };
        watchEffect(() => {
            if (props.value !== undefined) {
                state.url = props.value;
            }
        });
        // 检测图片宽高
        const interceptFileSizeRange = async (file) => {
            const { width, height } = await getRect(file);
            if (props.minSizeRange !== undefined) {
                const [minWidth, minHeight] = props.minSizeRange;
                if (width >= minWidth && height >= minHeight) {
                    return true;
                }
                else {
                    ctx.root.$message.warn(`图片大小至少${minWidth} * ${minHeight}, 当前${width} * ${height}`);
                    return false;
                }
            }
            else if (props.maxSizeRange !== undefined) {
                const [maxWidth, maxHeight] = props.maxSizeRange;
                if (width <= maxWidth && height <= maxHeight) {
                    return true;
                }
                else {
                    ctx.root.$message.warn(`图片大小不能超过${maxWidth} * ${maxHeight}, 当前${width} * ${height}`);
                    return false;
                }
            }
            else {
                return true;
            }
        };
        return { state: toRefs(state), setUrl, interceptFileSizeRange };
    },
    render() {
        const { data, url } = this.state;
        const UploadProps = {
            class: 'kr-another-uploader',
            props: {
                action: data.value.host,
                listType: 'picture-card',
                showUploadList: false,
                accept: '.jpg,.jpeg,.png',
                beforeUpload: async (file) => {
                    if (!interceptFileType(file)) {
                        this.$message.warn('图片格式不正确，请使用 jpg / jpeg / png');
                        return Promise.reject();
                    }
                    if (!interceptFileSize(file)) {
                        this.$message.warn(`${file.name} ${(file.size / ONE_MB).toFixed(2)}MB 请限制在2MB以内以内`);
                        return Promise.reject();
                    }
                    if (!(await this.interceptFileSizeRange(file))) {
                        return Promise.reject();
                    }
                    this.state.data.value = await ossRequest(file.name);
                },
                data: {
                    host: data.value.host,
                    key: data.value.key,
                    policy: data.value.policy,
                    OSSAccessKeyId: data.value.OSSAccessKeyId,
                    signature: data.value.signature,
                    success_action_status: `${data.value.success_action_status}`,
                },
            },
            on: {
                change: (params) => {
                    const { file } = params;
                    if (file.status === 'done') {
                        // on success
                        const url = parseOSSResponse(file.response);
                        this.setUrl(url);
                        this.onSuccess(url, file.originFileObj);
                    }
                },
            },
        };
        const maskProps = {
            class: 'mask',
            on: {
                click: (event) => {
                    event.stopPropagation();
                },
            },
        };
        const removeIconProps = {
            props: { type: 'delete' },
            on: {
                click: (event) => {
                    event.stopPropagation();
                    this.$emit('remove');
                },
            },
        };
        return (<Upload {...UploadProps}>
        {this.value && this.value !== '' ? (<img alt={data.value.key ?? ''} src={url.value} width={100} height={100}/>) : (<div>{this.emptyText}</div>)}
        {this.value && this.value !== '' ? (<div {...maskProps}>
            <Icon {...removeIconProps}/>
          </div>) : ('')}
      </Upload>);
    },
});
//# sourceMappingURL=index.jsx.map